export const TEMPLATES_API = {
  SEARCH_TEMPLATES: 'content/resourceTemplate/search'
}

export enum TEMPLATES_SCOPE {
  PUBLIC = 'PUBLIC',
  PRIVATE = 'PRIVATE'
}

export enum TEMPLATES_TYPES {
  PP = 'PP'
}

export const PAPER_SELECTED_TYPES = {
  EDUAC_PAPER: 'EDUAC_PAPER',
  USER_PAPER: 'USER_PAPER',
  UPLOAD: 'UPLOAD',
  NONE: 'NONE',
  UNDEF: 'UNDEF'
}

export const TEMPLATES_STORE_NAME = 'TemplatesStore';

export const TEMPLATES_MUTATIONS = {
  SET_EDUAC_PAPERS: 'setEduacPapers',
  SET_USER_PAPERS: 'setUserPapers',
  ADD_USER_PAPERS: 'addUserPapers',
  SET_USER_PAPER_SELECTED: 'setUserPaperSelected',
  SET_EDUAC_PAPER_SELECTED: 'setEduacPaperSelected',
  CLEAR_PAPER_SELECTED: 'clearPaperSelected',
  RESET_USER_PAPERS_LOAD: 'resetUserPapersLoad',
}

export const TEMPLATES_ACTIONS = {
  GET_EDUAC_PAPERS: 'getEduacPpapers',
  GET_USER_PAPERS: 'getUserPapers',
}

export const _TEMPLATES_STORE = {
  NAME: TEMPLATES_STORE_NAME,
  MUTATIONS: {
    SET_EDUAC_PAPERS: `${TEMPLATES_STORE_NAME}/${TEMPLATES_MUTATIONS.SET_EDUAC_PAPERS}`,
    SET_USER_PAPERS: `${TEMPLATES_STORE_NAME}/${TEMPLATES_MUTATIONS.SET_USER_PAPERS}`,
    ADD_USER_PAPERS: `${TEMPLATES_STORE_NAME}/${TEMPLATES_MUTATIONS.ADD_USER_PAPERS}`,
    SET_USER_PAPER_SELECTED: `${TEMPLATES_STORE_NAME}/${TEMPLATES_MUTATIONS.SET_USER_PAPER_SELECTED}`,
    SET_EDUAC_PAPER_SELECTED: `${TEMPLATES_STORE_NAME}/${TEMPLATES_MUTATIONS.SET_EDUAC_PAPER_SELECTED}`,
    CLEAR_PAPER_SELECTED: `${TEMPLATES_STORE_NAME}/${TEMPLATES_MUTATIONS.CLEAR_PAPER_SELECTED}`,
    RESET_USER_PAPERS_LOAD: `${TEMPLATES_STORE_NAME}/${TEMPLATES_MUTATIONS.RESET_USER_PAPERS_LOAD}`,
  },
  ACTIONS: {
    GET_EDUAC_PAPERS: `${TEMPLATES_STORE_NAME}/${TEMPLATES_ACTIONS.GET_EDUAC_PAPERS}`,
    GET_USER_PAPERS: `${TEMPLATES_STORE_NAME}/${TEMPLATES_ACTIONS.GET_USER_PAPERS}`,
  }
}

export const TEMPLATES_PAGE_SIZE = 80;
